import useFetch from '@/api/useFetch';
import { ErrorResponse } from '@/types/api/errorResponse';
import { Result } from '@/types/api/result';
import { QueryClient, useMutation } from '@tanstack/react-query';

import { WidgetCurrency } from './types';

export const WidgetCurrenciesQueryKey = ['widgetCurrencies'];

const useWidgetCurrencies = (queryClient?: QueryClient) => {
  const apiCall = useFetch();

  const queryOptions = {
    mutationFn: async (): Promise<Result<{ currencies: WidgetCurrency[] }>> => {
      try {
        const response = await apiCall('/currencies', 'GET');

        if (response.ok) {
          return {
            data: await response.json(),
            isSuccess: true
          };
        } else {
          return {
            isSuccess: false,
            error: (await response.json()) as unknown as ErrorResponse
          };
        }
      } catch (error) {
        return {
          isSuccess: false,
          error: error.message || (error as unknown as ErrorResponse)
        };
      }
    }
  };
  const mutation = useMutation(queryOptions, queryClient);

  const loadCurrencies = async () => {
    return await mutation.mutateAsync();
  };

  return { loadCurrencies };
};

export default useWidgetCurrencies;
